import { createSelector } from 'reselect';
import { uiSelector } from '../../common/state/selectors/issue-selector';

export const uiDraftsSelector = createSelector(uiSelector, (ui) => ui.drafts);

export const fieldHasDraftSelector = (fieldId: string) =>
	createSelector(uiDraftsSelector, (drafts) => !!drafts[fieldId]);
